<app-phone-details-display [product]="phoneProduct"></app-phone-details-display>
